import React from "react";
import { useState, createContext, useContext } from "react";
import { PropTypes } from "prop-types";

import { isAuthenticated, logout } from "../services/tokenService";
import usuarioService from "../services/usuarioService";

const authContext = createContext();

function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export function useAuth() {
  return useContext(authContext);
}

function useProvideAuth() {
  const INITIAL_STATE = isAuthenticated() ? usuarioService.getEmail() : null;

  const [user, setUser] = useState(INITIAL_STATE);

  const signin = (callback_function) => {
    setUser(usuarioService.getEmail());
    callback_function();
  };

  const signout = (callback_function) => {
    setUser(null);
    logout();
    callback_function();
  };

  return {
    user,
    signin,
    signout,
  };
}

ProvideAuth.propTypes = {
  children: PropTypes.element,
};

export default ProvideAuth;
